var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGmail = function SvgGmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 368 367"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 361.272,
    height: 361.272,
    x: 3.524,
    y: 2.863,
    fill: "url(#gmail_svg__a)",
    rx: 70.604
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 361.272,
    height: 361.272,
    x: 3.524,
    y: 2.863,
    stroke: "url(#gmail_svg__b)",
    strokeWidth: 5.502,
    rx: 70.604
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gmail_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M82.797 271.524h37.344v-90.693l-53.349-40.012v114.7c0 8.856 7.176 16.005 16.005 16.005"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M248.178 271.524h37.345c8.856 0 16.004-7.176 16.004-16.005v-114.7l-53.349 40.012"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M248.178 111.477v69.354l53.349-40.012V119.48c0-19.793-22.593-31.076-38.411-19.206"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M120.141 180.831v-69.354l64.019 48.014 64.018-48.014v69.354l-64.018 48.014"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5221F",
    d: "M66.792 119.48v21.339l53.349 40.012v-69.354l-14.938-11.203c-15.844-11.87-38.41-.587-38.41 19.206"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "gmail_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 92.024 92.136)scale(366.774)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gmail_svg__b",
    x1: 184.16,
    x2: 184.16,
    y1: 0.112,
    y2: 366.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D1D1",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gmail_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66.792 95.473h234.735v176.05H66.792z"
  })))));
};
export default SvgGmail;